
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
} from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import LogoIcon from 'src/assets/icons/LogoIcon';

import { useTheme } from 'src/hooks/useTheme';
import paths from 'src/navigation/paths';

const AppHeaderAuth: React.FC<{ onSidebarToggle?: () => void }> = ({
  onSidebarToggle,
}) => {
  const { mode } = useTheme();

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{
        zIndex: 1201,
        bgcolor: 'background.default',
        display: { xs: 'flex', md: 'none' }
      }}
    >
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Link
            to={paths.main}
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <LogoIcon color={mode === 'dark' ? 'custom.white' : 'custom.obsidian'} />
          </Link>
        </Box>
        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: 'flex', ml: 1 }}>
          <IconButton color="inherit" onClick={onSidebarToggle}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeaderAuth;
